'use client';

import React, { useEffect, useState, useRef } from 'react';
import { cn } from '@/utils/cn';
import Button from '../Button';
import Icon from '../Icon';
import TextXl from '../Typography/TextXl';
import TextBase from '../Typography/TextBase';
import ButtonLabel from '../Typography/ButtonLabel';

function WishlistItemRemoveConfirmModal({ onView, onClose }) {
  const [openModal, setOpenModal] = useState(onView);
  const modalRef = useRef(null);

  const handleClose = (data) => {
    setOpenModal(false);
    setTimeout(() => {
      onClose(data, false);
    }, 200);
  };

  useEffect(() => {
    if (onView) {
      setTimeout(() => {
        setOpenModal(true);
        document.body.style.overflow = 'hidden';
      }, 100);
    } else {
      setOpenModal(false);
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [onView]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        handleClose();
      }
    };

    if (openModal) {
      document.addEventListener('mousedown', handleOutsideClick);
    }

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [openModal]);

  return (
    <div
      className={cn(
        'w-full h-full bg-black/30 flex items-center justify-center opacity-0 -z-10 transition-all duration-300 fixed inset-0',
        openModal && '!opacity-100 !z-[501]',
      )}
    >
      <div
        ref={modalRef}
        className="w-full max-w-[480px] px-16 lg:px-24 py-16 lg:py-24 relative rounded-[4px] lg:rounded-[12px] transition-all duration-[400ms]"
      >
        <div className="mb-16">
          <Icon
            type="close"
            color="#fff"
            onClick={() => handleClose(false)}
            className="cursor-pointer ml-auto"
          />
        </div>
        <div className="bg-white p-24 rounded-xl shadow-product-slider-shadow">
          <TextXl
            text="Remove All Item?"
            className="text-lg lg:text-xl text-chokecherry text-center font-semibold mb-10 line-clamp-2"
          />
          <TextBase
            text="Do you want to remove all items from your wishlist?"
            className="text-sm lg:text-base text-center font-medium mb-20"
          />
          <div className="flex justify-between items-center gap-[16px]">
            <Button
              type="outline"
              className="w-full max-w-[208px] h-[36px] lg:h-[40px] !px-16 !py-10 !border-pacific-queen"
              onClick={() => handleClose(true)}
            >
              <ButtonLabel
                label="Remove"
                className="text-pacific-queen text-center text-sm font-bold"
              />
            </Button>
            <Button
              type="outline"
              className="w-full max-w-[208px] h-[36px] lg:h-[40px] !bg-pacific-queen !px-16 !py-10 !border-pacific-queen"
              onClick={() => handleClose(false)}
            >
              <ButtonLabel
                label="No, Keep"
                className="text-white text-center text-sm font-bold"
              />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WishlistItemRemoveConfirmModal;
